"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'route.payment.confirmed': 'Pagamento Confermato',
    'route.payment.list': 'Pagamenti',
    'route.payment.preview': 'Dettagli Pagamento',
};
